import React from "react";
import Title from "../layouts/Title";
import Experience from "./Experience";

const Resume = () => {
  return (
    <>
      <section id="experience" className="w-full py-20 section-divider">
        <div className="max-w-screen-xl mx-auto px-4">
          <Title title="Career Journey" />
          <Experience />
        </div>
      </section>
    </>
  );
};

export default Resume;
